export default __webpack_public_path__ + "static/media/dispatching.7c264b9f.svg";